export const GET_CATAGORY="get/catagory"
